import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { refreshSessionUser } from 'actions';

/**
 * Reconciles the session's roles with the server (GET /api/me) once per app
 * boot. The session is bootstrapped from the JWT, whose roles claim is a
 * LOGIN-TIME SNAPSHOT (24h TTL) — without this, a role granted after login
 * (e.g. ROLE_SUPER_ADMIN) never reaches the UI until re-login, hiding
 * controls the backend would actually allow.
 */
const SessionRefresh = () => {
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.userSession.isAuthenticated);

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(refreshSessionUser());
        }
    }, [isAuthenticated, dispatch]);

    return null;
};

export default SessionRefresh;
